import { render, staticRenderFns } from "./AppPages.vue?vue&type=template&id=5367dab5&scoped=true"
import script from "./AppPages.vue?vue&type=script&lang=js"
export * from "./AppPages.vue?vue&type=script&lang=js"
import style0 from "./AppPages.vue?vue&type=style&index=0&id=5367dab5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5367dab5",
  null
  
)

export default component.exports